import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../Header/Header';
// 移除不存在的 getPuzzles 导入
// import { getPuzzles } from '../../services/api';
import './Search.css';
import { pinyinSearch } from '../../utils/pinyinSearch';

const Search = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialQuery = queryParams.get('q') || '';
  
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allPuzzles, setAllPuzzles] = useState([]);
  
  // 监听URL变化
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get('q') || '';
    setSearchQuery(query);
    
    if (query && allPuzzles.length > 0) { // 确保谜题数据已加载
      performSearch(query);
    } else {
      setSearchResults([]);
    }
  }, [location.search, allPuzzles]); // 添加allPuzzles作为依赖项
  
  // 执行搜索，添加调试信息
  const performSearch = (query) => {
    setIsLoading(true);
    
    const puzzlesToSearch = Array.isArray(allPuzzles) ? allPuzzles : [];
    console.log('搜索关键词:', query);
    console.log('可搜索的谜题:', puzzlesToSearch);
    
    const results = pinyinSearch(query, puzzlesToSearch, ['title', 'description', 'creator']);
    console.log('搜索结果:', results);
    
    setSearchResults(results || []);
    setIsLoading(false);
  };
  
  // 加载所有谜题
  useEffect(() => {
    setIsLoading(true);
    
    // 模拟从服务器获取谜题数据
    setTimeout(() => {
      const mockPuzzles = [
        {
          id: 1,
          title: '消失的旅客',
          description: '一列火车穿过隧道，出来时少了一名乘客...',
          creator: '拍拍',
          date: '2025-02-28',
          views: 342,
          comments: 4,
          favorites: 128,
          cover: '/images/puzzle1.jpg', // 使用本地图片
          difficulty: '中等'
        },
        {
          id: 2,
          title: '奇怪的遗嘱',
          description: '富翁留下的遗嘱中只有一句话：向北走十步...',
          creator: '拍拍',
          date: '2025-02-25',
          views: 287,
          comments: 4,
          favorites: 93,
          cover: '/images/puzzle2.jpg', // 使用本地图片
          difficulty: '困难'
        },
        {
          id: 3,
          title: '雨夜里的陌生人',
          description: '暴雨中，一个陌生人敲开了独居老人的门...',
          creator: '拍拍',
          date: '2025-04-21',
          views: 332,
          comments: 4,
          favorites: 215,
          cover: '/images/puzzle3.jpg', // 使用本地图片
          difficulty: '简单'
        },
        {
          id: 4,
          title: '空中楼阁',
          description: '他看到了一座悬浮在空中的城堡，但没人相信他...',
          creator: '拍拍',
          date: '2025-04-01',
          views: 245,
          comments: 4,
          favorites: 84,
          cover: '/images/puzzle4.jpg', // 使用本地图片
          difficulty: '中等'
        },
        {
          id: 5,
          title: '镜中世界',
          description: '他发现镜子里的自己有时会做出不同的动作...',
          creator: '拍拍',
          date: '2025-04-13',
          views: 310,
          comments: 4,
          favorites: 176,
          cover: '/images/puzzle5.jpg', // 使用本地图片
          difficulty: '困难'
        },
        {
          id: 6,
          title: '午夜来电',
          description: '每天午夜，她都会收到一通未知号码的电话...',
          creator: '拍拍',
          date: '2025-03-21',
          views: 224,
          comments: 4,
          favorites: 68,
          cover: '/images/puzzle6.jpg', // 使用本地图片
          difficulty: '中等'
        },
        {
          id: 7,
          title: '沉默的窃贼',
          description: '银行被盗，但监控录像显示没有人进出...',
          creator: '拍拍',
          date: '2025-01-29',
          views: 356,
          comments: 4,
          favorites: 105,
          cover: '/images/puzzle7.jpg', // 使用本地图片
          difficulty: '困难'
        },
        {
          id: 8,
          title: '诡异的录音',
          description: '科学家在无人岛上录到了人声...',
          creator: '拍拍',
          date: '2025-01-13',
          views: 302,
          comments: 4,
          favorites: 156,
          cover: '/images/puzzle8.jpg', // 使用本地图片
          difficulty: '中等'
        }
      ];
      
      setAllPuzzles(mockPuzzles);
      
      // 执行初始搜索
      if (initialQuery) {
        performSearch(initialQuery);
      }
      
      setIsLoading(false);
    }, 800);
  }, []);
  
  // 处理搜索
  const handleSearch = (e) => {
    e.preventDefault();
    
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }
    
    setIsLoading(true);
    
    // 使用拼音搜索功能，确保allPuzzles是数组
    const puzzlesToSearch = Array.isArray(allPuzzles) ? allPuzzles : [];
    const results = pinyinSearch(searchQuery, puzzlesToSearch, ['title', 'description', 'creator']);
    setSearchResults(results || []); // 确保结果是数组
    
    setIsLoading(false);
    
    // 更新URL，但不刷新页面
    const newUrl = `/search?q=${encodeURIComponent(searchQuery)}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  };
  
  // 添加输入框变化处理程序
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };
  
  return (
    <div className="elegant-app">
      <Header />
      
      <main className="elegant-main">
        <div className="elegant-search-container">
          <div className="elegant-search-header">
            <h1 className="elegant-search-title">
              "{searchQuery}" 的搜索结果
            </h1>
            <p className="elegant-search-info">
              找到 {searchResults.length} 条结果
            </p>
          </div>
          
          <div className="search-results">
            {isLoading ? (
              <div className="elegant-loading-spinner">
                <div className="elegant-loading-spinner-inner"></div>
              </div>
            ) : searchResults && searchResults.length > 0 ? (
              <>
                <h2>搜索结果 ({searchResults.length})</h2>
                <div className="puzzle-grid">
                  {searchResults.map(puzzle => (
                    <Link 
                      to={`/puzzle/${puzzle.id}`} 
                      key={puzzle.id} 
                      className="puzzle-card"
                    >
                      <div className="puzzle-image">
                        <div className="puzzle-image-placeholder"></div>
                        <img 
                          src={puzzle.cover || '/images/default.png'} 
                          alt={puzzle.title}
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/images/default.png';
                          }}
                        />
                      </div>
                      <div className="puzzle-info">
                        <h3>{puzzle.title}</h3>
                        <div className="puzzle-meta-author">
                          <span className="puzzle-creator">
                            {puzzle.creator || puzzle.author.username || "匿名用户"}
                          </span>
                          <span className="puzzle-likes">
                            <i className="fas fa-heart"></i> {puzzle.favorites || 0}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </>
            ) : searchQuery ? (
              <div className="no-results">
                <i className="fas fa-search"></i>
                <p>没有找到与 "{searchQuery}" 相关的谜题</p>
              </div>
            ) : (
              <div className="search-placeholder">
                <i className="fas fa-search"></i>
                <p>输入关键词开始搜索</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Search;